import * as React from 'react';
import styled from 'styled-components';

import { verticalSpace } from '@doltech/utils/lib/css-style';
import { getSlateEditorValue, isValidSlateNodeValue } from '@doltech/utils/lib/editor';

import { colorsV2 } from '../../colors-v2';
import { RendererWithPlugins } from '../../../slatePlugins/components/core/readonly/RendererWithPlugins';
import { ParagraphPlugin } from '../../../slatePlugins/components/core/readonly/ParagraphPlugin';
import { BoldReadOnlyPlugin } from '../../../slatePlugins/marks/bold/BoldReadOnlyPlugin';
import { ItalicReadOnlyPlugin } from '../../../slatePlugins/marks/italic/ItalicReadOnlyPlugin';
import { UnderlineReadOnlyPlugin } from '../../../slatePlugins/marks/underline/UnderlinePlugin';
import { HyperLinkElementReadOnlyPlugin } from '../../DolEditor/elements/hyper-link/HyperLinkElementReadOnlyPlugin';

const plugins = [
  ParagraphPlugin,
  BoldReadOnlyPlugin(),
  ItalicReadOnlyPlugin(),
  UnderlineReadOnlyPlugin(),
  HyperLinkElementReadOnlyPlugin(),
];

const Container = styled.div`
  ${verticalSpace(8)}

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
    border: 1px solid ${colorsV2.neutral20};
  }

  a {
    cursor: pointer;
    color: ${colorsV2.blue100};

    &:hover {
      text-decoration-line: underline;
    }

    &:active {
      color: ${colorsV2.blue140};
    }
  }
`;

interface BlogPageElementCoverProps {
  cover?: any;
}

export const BlogPageElementCover = (props: BlogPageElementCoverProps) => {
  const { cover } = props;

  return (
    <Container>
      <img src={cover?.url} alt={cover?.alt} />
      {isValidSlateNodeValue(cover?.caption) && (
        <RendererWithPlugins plugins={plugins} value={getSlateEditorValue(cover?.caption)} />
      )}
    </Container>
  );
};
